<template>
  <div>
    <yv-form-search
      :formSearch="baseFormSearch"
      :inlineSearchAction="true"
      :enableExport="false"
      @search="search"
      ref="formReport"
    >
      <template #search-actions="{ actions }">
        <md-button
          native-type="submit"
          @click.native.prevent="actions.search"
          class="md-info md-round"
          >{{ $t("common.search") }}
        </md-button>
      </template>
    </yv-form-search>
    <div style="height: auto">
      <no-data-found v-if="!listStudentAssigned.length"></no-data-found>
      <div v-else>
        <div class="flex">
          <md-checkbox class="m-0 pl-6" v-model="isSelectAllSearchResults">{{
            $t("progress_report.select_all_student_in_search_results")
          }}</md-checkbox>
          <selections-box
            :title="$t('common.per_page')"
            :options="perPageOptions"
            :default="pagination.perPage"
            :style="{ marginLeft: 'auto' }"
            @input="changePerPage"
          />
        </div>
        <md-table
          class="mt-2"
          v-model="listStudentAssigned"
          md-card
          @md-selected="onSelect"
        >
          <md-table-row
            slot="md-table-row"
            slot-scope="{ item }"
            md-selectable="multiple"
            md-auto-select
            :md-disabled="isDisable"
          >
            <md-table-cell :md-label="$t('common.student_id')">
              <img
                class="object-cover rounded-full w-[42px] h-[42px]"
                :src="item.avatar_url || '/img/avt_placeholder.jpg'"
              />
            </md-table-cell>
            <md-table-cell :md-label="$t('common.student_id')">{{
              item.student_code
            }}</md-table-cell>
            <md-table-cell :md-label="$t('common.username')">{{
              item.username
            }}</md-table-cell>
            <md-table-cell :md-label="$t('common.full_name')">{{
              item.full_name
            }}</md-table-cell>
            <md-table-cell :md-label="$t('common.grade')">{{
              item.grade
            }}</md-table-cell>
            <md-table-cell :md-label="$t('common.sex')">{{
              item.sex
            }}</md-table-cell>
          </md-table-row>
        </md-table>
      </div>
      <yv-pagination
        v-if="listStudentAssigned.length"
        :pagination="pagination"
        @changePage="changePage"
      ></yv-pagination>
    </div>
  </div>
</template>

<script>
import YvFormSearch from "@/components/Base/YvFormSearch.vue";
import { Message, getId } from "@/helpers/utils";
import { service_paths, service_names } from "@/constants/Services";
import YvPagination from "@/components/Base/YvPagination";
import { DEFAULT_OPTION_ALL } from "@/constants";
import debounce from "lodash/debounce";
import SelectionsBox from "@/components/Base/SelectionsBox";
export default {
  components: { YvPagination, YvFormSearch, SelectionsBox },
  props: ["staffIdSelected", "currentAuthorized", "staffNameSelected"],
  data() {
    return {
      perPageOptions: [5, 10, 25, 50],
      baseFormSearch: [
        {
          label: "progress_report.program",
          name: "program_id",
          value: "",
          type: "select",
          options: []
        },
        {
          label: "progress_report.grade",
          name: "grade",
          value: "",
          options: [],
          type: "select"
        },
        {
          label: "progress_report.full_name_student_id",
          name: "search_key",
          value: "",
          type: "text"
        },
        {
          label: "common.status",
          name: "status",
          value: "Active",
          type: "select",
          options: [
            { name: "common.active", id: "Active" },
            { name: "common.inactive", id: "Inactive" }
          ]
        },
        {
          label: "schedule.filter_by_class",
          name: "class_ids",
          value: [],
          type: "checkbox-multi-select",
          options: [],
          trackBy: "id",
          displayField: "name",
          filtering: this.filtering
        }
      ],
      selectedClassId: this.selectedClass,
      isSelectAllSearchResults: false,
      selectedDateValue: "",
      tableData: [],
      student_ids: [],
      isDisable: false,
      pagination: {
        perPage: 10,
        from: 0,
        hidePerPageOptions: true,
        to: 0,
        total: 0,
        currentPage: 1
      },
      listStudentAssigned: [],
      currentQueryParams: null,
      classOptsSelected: []
    };
  },
  created() {
    this.fetchGradeOpts();
    this.fetchProgramOpts();
    this.search();
    this.fetchClassOpts();
  },
  computed: {
    classIdSelected() {
      return this.baseFormSearch[4].value;
    },
    classOpts() {
      return this.baseFormSearch[4].options;
    },
    debounceSearchKey() {
      const self = this;
      return debounce(function(searchKey) {
        self.fetchClassOpts(searchKey);
      }, 500);
    }
  },
  watch: {
    isSelectAllSearchResults: function(value) {
      this.isDisable = !this.isDisable;
    },
    classIdSelected: function(newVal) {
      this.fetchClassOpts();
      this.classOptsSelected = this.classOpts.filter(item =>
        newVal.includes(item.id)
      );
    }
  },
  methods: {
    changePerPage(value) {
      this.pagination.perPage = value;
      this.currentQueryParams.limit = value;
      this.fetchStudentOpts(this.currentQueryParams);
    },
    async fetchClassOpts(searchKey) {
      const { data } = await this.$axios.get(
        `${service_names.school}/classes`,
        {
          "name__~": searchKey || "",
          limit: 50
        },
        undefined,
        undefined,
        undefined,
        undefined,
        false
      );
      let options = data.data.filter(
        item => !this.classIdSelected.includes(item.id)
      );
      this.baseFormSearch[4].options = [...this.classOptsSelected, ...options];
    },
    filtering(event) {
      this.debounceSearchKey(event);
    },
    search(queryParams) {
      this.pagination.currentPage = 1;
      const defaultQuery = {
        grade: "",
        search_key: "",
        program_id: "",
        status: "Active",
        class_ids: [],
        authorized: this.currentAuthorized
      };
      let query = queryParams || defaultQuery;
      this.currentQueryParams = {
        ...query,
        fields: ["full_name", "student_code"],
        staff_id: this.staffIdSelected,
        authorized: this.currentAuthorized,
        page: this.pagination.currentPage,
        limit: this.pagination.perPage
      };
      this.isSelectAllSearchResults = false;
      this.fetchStudentOpts(this.currentQueryParams);
    },
    changePage() {
      let params = {
        ...this.currentQueryParams,
        page: this.pagination.currentPage,
        limit: this.currentQueryParams.limit || this.pagination.perPage
      };
      this.fetchStudentOpts(params);
    },
    onSelect(items) {
      this.student_ids = items.map(item => getId(item));
    },
    fetchStudentOpts(query) {
      this.$axios
        .get(`${service_names.user}/progress-setting/students`, query)
        .then(response => {
          this.listStudentAssigned = response.data.data;
          this.pagination.from = response.data.from;
          this.pagination.to = response.data.to;
          this.pagination.total = response.data.total;
        });
    },
    fetchGradeOpts() {
      this.$axios
        .get(`${service_paths.grades}`, { limit: 20 })
        .then(response => {
          const gradeList = response?.data?.data.map(item => {
            return { name: item.name, id: item.name };
          });
          this.baseFormSearch[1].options = [
            ...DEFAULT_OPTION_ALL,
            ...gradeList
          ];
        });
    },

    fetchProgramOpts() {
      this.$axios
        .get(`${service_paths.programs}`, { limit: 150 })
        .then(response => {
          const programList = response?.data?.data
            .map(program => ({
              id: getId(program),
              name: program.name
            }))
            .sort((currentProgram, newProgram) => {
              return currentProgram.name.localeCompare(newProgram.name);
            });
          this.baseFormSearch[0].options = [
            ...DEFAULT_OPTION_ALL,
            ...programList
          ];
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
